import { useQuery } from '@tanstack/react-query'
import { queryNames } from '../../queries'
import { AxiosError } from 'axios'
import { useTranslation } from 'react-i18next'
import { SearchListOptionsDto } from '../../../api/data/types'
import { showErrorToast } from '../../../utils/errors'
import DataApi from '../../../api/data/DataApi'
import { HttpError } from '../../../types/common'
import { mapPlaceListDto } from '../../../mapping/locations'
import { LocationList } from '../../../types/locations'

const dataApi = DataApi.getInstance()

type Options = {
  enabled: boolean
  onSuccess: (data: LocationList) => void
}

export default function useGetPlaceList(options: SearchListOptionsDto & Options) {
  const texts = useTranslation().t

  const query = useQuery([queryNames.getPlaceList, options.search, options.limit, options.offset], async () => {
    const { data } = await dataApi.getPlaceList(options)
    return mapPlaceListDto(data)
  }, {
    staleTime: Infinity,
    refetchOnMount: 'always',
    enabled: options.enabled,
    onSuccess: options.onSuccess,
    onError: (error: AxiosError<HttpError>) => {
      showErrorToast(error, texts)
    }
  })

  return query
}
